export default {
    namespaced:true,
    state:{
        roles:[]
    },
    mutations:{
        SET_ROLES(state, roles){
            state.roles.push(...roles.map(rol=>{
                if(rol.getACL().permissionsById['*'] === undefined){
                    return {
                        role:rol,
                        roleName:rol.getName(),
                        read:false,
                        write:false
                    }
                }
                let canRead = rol.getACL().permissionsById['*'].read;
                let canWrite = rol.getACL().permissionsById['*'].write;
                console.log();
                return {
                    role:rol,
                    roleName:rol.getName(),
                    read:canRead === undefined ? false: canRead,
                    write:canWrite === undefined ? false: canWrite
                }
            }));
        }
    },
    getters:{
        getRoles:(state)=>{
            return state.roles;
        }
    }
}